export default __webpack_public_path__ + "static/media/home2.560a6566.png";